(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["banner-full-width-with-pill"] && !Shopify.designMode) return;
  try {
    // The background video carries `autoplay`, which CSS cannot undo. Honour
  // prefers-reduced-motion by pausing it on its first frame instead.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video.banner-full-width-pill__img').forEach((video) => {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.pause();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["banner-full-width"] && !Shopify.designMode) return;
  try {
    // The background video carries `autoplay`, which CSS cannot undo. Honour
  // prefers-reduced-motion by pausing it on its first frame instead.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video.banner-full-width__img').forEach((video) => {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.pause();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('[data-collection-carousel]');

    carousels.forEach(function(carousel) {
      const swiper = carousel.querySelector('.swiper');
      const wrapper = carousel.querySelector('.swiper-wrapper');

      if (!swiper || !wrapper) return;

      function checkScrollable() {
        const isScrollable = wrapper.scrollWidth > swiper.clientWidth;
        carousel.classList.toggle('is-scrollable', isScrollable);
      }

      // Check on load
      checkScrollable();

      // Check on resize
      window.addEventListener('resize', checkScrollable);

      // Re-check after Swiper initializes (slight delay)
      setTimeout(checkScrollable, 100);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collections-tabs"] && !Shopify.designMode) return;
  try {
    // Equalize product card title heights across ALL tabs at once
  (function() {
  const blockStates = new WeakMap();

  function equalizeProductCardHeights(block) {
    if (blockStates.get(block)) return;

    block.style.visibility = 'hidden';

    const tabContents = block.querySelectorAll('.tab-content');

    const originalStyles = [];
    tabContents.forEach(tab => {
      originalStyles.push({
        el: tab,
        display: tab.style.display,
        height: tab.style.height,
        overflow: tab.style.overflow
      });
      tab.style.display = 'block';
      tab.style.height = 'auto';
      tab.style.overflow = 'visible';
    });

    const allTitles = block.querySelectorAll('.product-card__title');

    originalStyles.forEach(item => {
      item.el.style.display = item.display;
      item.el.style.height = item.height;
      item.el.style.overflow = item.overflow;
    });

    blockStates.set(block, true);
    block.style.visibility = '';
    block.classList.add('is-initialized');
  }

  function equalizeAll() {
    document.querySelectorAll('.collections-tabs-block').forEach(block => {
      equalizeProductCardHeights(block);
    });
  }

  function resetAll() {
    document.querySelectorAll('.collections-tabs-block').forEach(block => {
      blockStates.set(block, false);
      block.classList.remove('is-initialized');
      equalizeProductCardHeights(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeAll);
  } else {
    equalizeAll();
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resetAll, 150);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["large-tile"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const largeTiles = document.querySelectorAll('.large-tile');
    function groupByRow(elements) {
      const rows = [];
      elements.forEach(el => {
        el.style.height = ''; 
        const top = Math.round(el.getBoundingClientRect().top); 
        let found = false;
        for (const row of rows) {
          if (Math.abs(row.top - top) < 4) { 
            row.elements.push(el);
            found = true;
            break;
          }
        }
        if (!found) rows.push({ top, elements: [el] });
      });
      return rows;
    }
    function onImagesLoaded(containerElements, callback) {
      let images = [];
      containerElements.forEach(container => {
        images = images.concat(Array.from(container.querySelectorAll('img')));
      });
      let loaded = 0;
      if (images.length === 0) { callback(); return; }
      images.forEach(img => {
        if (img.complete) {
          loaded++;
          if (loaded === images.length) callback();
        } else {
          img.addEventListener('load', () => {
            loaded++;
            if (loaded === images.length) callback();
          });
          img.addEventListener('error', () => {
            loaded++;
            if (loaded === images.length) callback();
          });
        }
      });
    }

    function syncRowHeights() {
      const secondaryBodyDivs = Array.from(largeTiles)
        .map(tile => tile.querySelector('.tile__secondary-body-content'))
        .filter(Boolean);
      if (secondaryBodyDivs.length > 1) {
        const secondaryRows = groupByRow(secondaryBodyDivs.filter(div => div.offsetParent !== null));
        secondaryRows.forEach(row => {
          let maxHeight = 0;
          row.elements.forEach(div => {
            div.style.height = '';
            const h = div.offsetHeight;
            if (h > maxHeight) maxHeight = h;
          });
          row.elements.forEach(div => {
            div.style.height = maxHeight + 'px';
          });
        });
      }
      const contentWrapperDivs = Array.from(largeTiles)
        .map(tile => tile.querySelector('.tile__content-wrapper'))
        .filter(Boolean);

      if (contentWrapperDivs.length > 1) {
        const contentRows = groupByRow(contentWrapperDivs.filter(div => div.offsetParent !== null));
        contentRows.forEach(row => {
          let maxHeight = 0;
          row.elements.forEach(div => {
            div.style.height = '';
            const h = div.offsetHeight;
            if (h > maxHeight) maxHeight = h;
          });
          row.elements.forEach(div => {
            div.style.height = maxHeight + 'px';
          });
        });
      }
    }

    const secondaryBodyDivs = Array.from(largeTiles)
      .map(tile => tile.querySelector('.tile__secondary-body-content'))
      .filter(Boolean);

    onImagesLoaded(secondaryBodyDivs, syncRowHeights);
    window.addEventListener('resize', syncRowHeights);
    window.addEventListener('orientationchange', syncRowHeights);

    setTimeout(syncRowHeights, 150);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["page-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('[data-page-carousel]');

    carousels.forEach(function(carousel) {
      const swiper = carousel.querySelector('.swiper');
      const wrapper = carousel.querySelector('.swiper-wrapper');

      if (!swiper || !wrapper) return;

      function checkScrollable() {
        const isScrollable = wrapper.scrollWidth > swiper.clientWidth;
        carousel.classList.toggle('is-scrollable', isScrollable);
      }

      // Check on load
      checkScrollable();

      // Check on resize
      window.addEventListener('resize', checkScrollable);

      // Re-check after Swiper initializes (slight delay)
      setTimeout(checkScrollable, 100);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sf-product-carousel"] && !Shopify.designMode) return;
  try {
    // Equalize product card title heights across ALL tabs at once
  (function() {
  const blockStates = new WeakMap();

  function equalizeProductCardHeights(block) {
    if (blockStates.get(block)) return;

    block.style.visibility = 'hidden';

    const tabContents = block.querySelectorAll('.tab-content');

    const originalStyles = [];
    tabContents.forEach(tab => {
      originalStyles.push({
        el: tab,
        display: tab.style.display,
        height: tab.style.height,
        overflow: tab.style.overflow
      });
      tab.style.display = 'block';
      tab.style.height = 'auto';
      tab.style.overflow = 'visible';
    });

    const allTitles = block.querySelectorAll('.product-card__title');

    originalStyles.forEach(item => {
      item.el.style.display = item.display;
      item.el.style.height = item.height;
      item.el.style.overflow = item.overflow;
    });

    blockStates.set(block, true);
    block.style.visibility = '';
    block.classList.add('is-initialized');
  }

  function equalizeAll() {
    document.querySelectorAll('.collections-tabs-block').forEach(block => {
      equalizeProductCardHeights(block);
    });
  }

  function resetAll() {
    document.querySelectorAll('.collections-tabs-block').forEach(block => {
      blockStates.set(block, false);
      block.classList.remove('is-initialized');
      equalizeProductCardHeights(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeAll);
  } else {
    equalizeAll();
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resetAll, 150);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["simple-accordion"] && !Shopify.designMode) return;
  try {
    class SimpleAccordionRow extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('.simple-accordion-row__header');
      this.bindEvents();
    }

    bindEvents() {
      this.header?.addEventListener('click', () => this.toggle());
    }

    toggle() {
      if (this.hasAttribute('open')) {
        this.removeAttribute('open');
      } else {
        this.setAttribute('open', '');
      }
      // Keep the button's aria-expanded in sync so screen readers announce state.
      this.header?.setAttribute('aria-expanded', String(this.hasAttribute('open')));
    }
  }

  if (!customElements.get('simple-accordion-row')) {
    customElements.define('simple-accordion-row', SimpleAccordionRow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-header-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const stickyHeaderContent = document.querySelector('.sticky-header-content');
    const anchors = document.querySelectorAll('.sticky-header-content__menu a');
    const anchorSectionPairs = Array.from(anchors).map(anchor => {
        const href = anchor.getAttribute('href');
        if (!href || !href.includes('#')) return null;
        const id = href.split('#')[1];
        const section = document.getElementById(id);
        return section ? { anchor, section } : null;
    }).filter(Boolean);

    function clearActive() {
        anchors.forEach(anchor => anchor.parentElement && anchor.parentElement.classList.remove('active'));
    }

    function setActiveOnScroll() {
        let found = false;
        for (let i = anchorSectionPairs.length - 1; i >= 0; i--) {
            const { anchor, section } = anchorSectionPairs[i];
            const rect = section.getBoundingClientRect();
            if (rect.top <= stickyHeaderContent.offsetHeight) {
                clearActive();
                anchor.parentElement && anchor.parentElement.classList.add('active');
                found = true;
                break;
            }
        }
      
    }

    window.addEventListener('scroll', setActiveOnScroll, { passive: true });
    setActiveOnScroll();

    anchors.forEach(anchor => {
        anchor.addEventListener('click', function() {
            clearActive();
            anchor.parentElement && anchor.parentElement.classList.add('active');
         
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tile-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tileGrids = document.querySelectorAll('[data-tile-grid-items]');
    tileGrids.forEach(function(grid) {
      const tiles = grid.children;
      // Limit visible tiles to 6 (also handled via CSS nth-child)
      for (let i = 6; i < tiles.length; i++) {
        tiles[i].style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
